import { useEffect, useState } from "react";
import { getGlossary } from "../../api/searchApi";
import GlossaryItem from "./glossaryItem";

export default function Glossary() {
    const [glossary, setGlossary] = useState(null);

    useEffect(() => {
        const doFetch = async () => {
            const result = await getGlossary();

            setGlossary(result);
        };

        doFetch();
    }, []);

    if (!glossary)
        return null;

    return (
        <>
            {glossary.map(g => <GlossaryItem key={g.term} item={g} />)}
        </>
    );
}